import React from "react";
import { createContext } from "@wss/react";
type FeatureFlagState = {
  featureFlags: Record<string, boolean>;
  evaluateFlag: (key: string) => boolean;
};
const [FeatureFlagContext, useContext] = createContext<FeatureFlagState>();
export const useFeatureFlag = () => useContext();
interface FeatureFlagProviderProps {
  featureFlags?: Record<string, boolean>;
  children: React.ReactNode;
}
const FeatureFlagProvider = ({
  featureFlags = {},
  children
}: FeatureFlagProviderProps) => {
  const value: FeatureFlagState = {
    featureFlags,
    evaluateFlag: (key: string) => featureFlags[key] ?? false
  };
  return <FeatureFlagContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="FeatureFlagProvider" data-sentry-source-file="index.tsx">
      {children}
    </FeatureFlagContext.Provider>;
};
export default FeatureFlagProvider;